module.exports = {
	"articleTitle1": "Yost Ice Arena: A Michigan tradition ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Yost Ice Arena",
	"articleLink2": "https://www.michigandaily.com/section/ice-hockey/yost-ice-arena-earns-approval-st-louis-blues-organization",
	"articleSnippet1": "Jan 24, 2017 ... The Michigan hockey team has played in Yost Ice Arena for the past 43 seasons, \nand it has become a special place for the Wolverines.",
	"articleSnippet2": "Oct 5, 2015 ... Two members of the St. Louis Blues reflect on the improvements at Yost.",
	"totalMisc": 0,
	"articleTitle2": "Yost Ice Arena earns approval of St. Louis Blues organization ",
	"address": "1116 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170124/zqh.HKY_.vsUnion.10.7.16.057.jpg?itok=nOpy_MSW",
			"author": "Zoey Holmstrom",
			"caption": "The Michigan hockey team has played in Yost Ice Arena for the past 43 seasons, and it has become a special place for the Wolverines."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170205/eaa.HKY_.64_0.gif?itok=moFO9cor",
			"author": "Evan Aaron",
			"caption": "Michigan students at the hockey game against Ohio State on Saturday."
		}
	],
	"position": {
		"lat": 42.267574,
		"lng": -83.740989
	},
	"tips": [
		{
			"text": "Really cool atmosphere for hockey games. I recommend going to at least one game here.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "#",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/yosticearena.json
// module id = 1003
// module chunks = 0